<template>
    <div class="edit-box__section" v-if="onlyDayPrices && dataCopy.id">
                        <span class="label is-inline-block edit-box__includes-inline-input">
                            {{ $t('generic.price_changes_1') }}
                            <router-link exact :to="{ name: 'dayprices', params: {lang: lang} }" class="is-small">
                                <span class="icon is-small" style="padding-top: 6px">
                                    <i class="fa fa-arrow-right" aria-hidden="true" />
                                </span>
                                <span>{{ $t('generic.price_changes_2') }}</span>
                            </router-link>
                            {{ $t('generic.price_changes_3') }}
                        </span>
    </div>
</template>
<script>
export default {
    name: 'UseDayPrices',
    props: {
        lang: {},
        onlyDayPrices: {},
        dataCopy: {}
    }
};
</script>



// WEBPACK FOOTER //
// src/views/components/tools/UseDayPrices.vue